module.exports = __webpack_public_path__ + "static/media/confused-travolta.6e5f6ca4.gif";